import { z } from "zod";

const nonEmptyString = z.string().min(1);

export const giftCardformSchema = z.object({
    id: z.number().optional(),
    partner: nonEmptyString,
    imageUrl: nonEmptyString,
    category: nonEmptyString,
    termsAndConditions: nonEmptyString,
    type: z.string() as z.ZodType<'onDemand' | 'stock'>,
    denominations: z.array(z.number().positive()),
    closingTime: z.string().min(1).optional(),
    agreementCode: z.string().min(1).optional(),
}).refine(
    (data) => data.type !== 'onDemand' || data.denominations.length > 0,
    {
        message: 'At least one denomination is required',
        path: ['denominations'],
    }
);

export type GiftCardFormDto = z.infer<typeof giftCardformSchema>;

export type GiftCardFormDtoKey = keyof GiftCardFormDto;
